module.exports = __webpack_public_path__ + "media/images/icons-962da39e3fe9d4ac8539f805a9ceabaa.svg";